import { useState } from 'react';
import { FilledInput, InputAdornment, IconButton, InputLabel } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles, type Theme } from '@material-ui/core/styles';
import { VisibilityOff, Visibility } from '@material-ui/icons';
import FormControl from '@mui/material/FormControl';
import axios from 'axios';
import { useStore } from 'react-redux';
import * as helper from '../../../../helper/index';
import { toastr } from 'react-redux-toastr';

const useStyles = makeStyles((theme: Theme) => ({
  fromControl: {
    width: '100%',
  },
}));

export default function Change_password() {
  const classes = useStyles();
  const store: any = useStore();

  const [get_old_password, set_old_password] = useState('');
  const [get_new_password, set_new_password] = useState('');
  const [get_verify_new_password, set_verify_new_password] = useState('');

  const [get_old_password_masking, set_old_password_masking] = useState(false);
  const [get_new_password_masking, set_new_password_masking] = useState(false);
  const [get_verify_new_password_masking, set_verify_new_password_masking] = useState(false);

  async function change_password() {
    await axios
      .post(
        `${process.env.REACT_APP_API_SERVER}/account/change_password`,
        {
          old_password: get_old_password,
          new_password: get_new_password,
          verify_new_password: get_verify_new_password,
        },
        {
          headers: {
            Authorization: `Bearer ${store.getState().auth.jwt}`,
          },
        },
      )
      .then((res) => {
        if (res.data) {
          toastr.success('Success', 'Password changed successfully');
          set_old_password('');
          set_new_password('');
          set_verify_new_password('');
        }
      })
      .catch((e) => {
        helper.axiosErrorHandling(e);
      });
  }

  return (
    <div>
      <Grid item xs={12} md={4}>
        <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Old Password</InputLabel>
          <FilledInput
            fullWidth
            required={true}
            className={classes.fromControl}
            value={get_old_password}
            onChange={(e) => {
              set_old_password(e.target.value);
            }}
            type={get_old_password_masking ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => {
                    set_old_password_masking(!get_old_password_masking);
                  }}
                  onMouseDown={() => {}}
                  edge="end"
                >
                  {!get_old_password_masking ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
          <FilledInput
            fullWidth
            required={true}
            className={classes.fromControl}
            value={get_new_password}
            onChange={(e) => {
              set_new_password(e.target.value);
            }}
            type={get_new_password_masking ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => {
                    set_new_password_masking(!get_new_password_masking);
                  }}
                  onMouseDown={() => {}}
                  edge="end"
                >
                  {!get_new_password_masking ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Verify New Password</InputLabel>
          <FilledInput
            fullWidth
            required={true}
            className={classes.fromControl}
            value={get_verify_new_password}
            onChange={(e) => {
              set_verify_new_password(e.target.value);
            }}
            type={get_verify_new_password_masking ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => {
                    set_verify_new_password_masking(!get_verify_new_password_masking);
                  }}
                  onMouseDown={() => {}}
                  edge="end"
                >
                  {!get_verify_new_password_masking ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <Button variant="contained" color="primary" onClick={change_password}>
          Change Password
        </Button>
      </Grid>
    </div>
  );
}
